/**
 *
 * Carousel
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './styles.css';
import ArrowLeft from 'components/Carousel/images/arrow-left.svg';
import ArrowRight from 'components/Carousel/images/arrow-right.svg';

const CustomLeftArrow = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="cm-resources-custom-left-arrow"
  >
    <img src={ArrowLeft} alt="Arrow Left" />
  </button>
);
const CustomRightArrow = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="cm-resources-custom-right-arrow"
  >
    <img src={ArrowRight} alt="Arrow Right" />
  </button>
);

function ResourcesCarousel(props) {
  const {
    children,
    slidesToSlide,
    swipeable,
    responsive,
    infinite,
    partialVisible,
    arrows,
  } = props;
  return (
    <Carousel
      additionalTransform={0}
      arrows={arrows}
      centerMode={false}
      customLeftArrow={<CustomLeftArrow />}
      customRightArrow={<CustomRightArrow />}
      containerClass="cm-resources-carousel-container"
      dotListClass=""
      draggable
      focusOnSelect={false}
      itemClass="cm-resources-carousel-item"
      keyBoardControl
      partialVisible={partialVisible}
      minimumTouchDrag={80}
      renderDotsOutside={false}
      showDots={false}
      sliderClass="cm-resources-carousel-slider"
      slidesToSlide={slidesToSlide}
      swipeable={swipeable}
      infinite={infinite}
      responsive={
        responsive || {
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 4,
            partialVisibilityGutter: 40,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0,
            },
            items: 2,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464,
            },
            items: 3,
            partialVisibilityGutter: 30,
          },
        }
      }
    >
      {children}
    </Carousel>
  );
}

ResourcesCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  slidesToSlide: PropTypes.number,
  swipeable: PropTypes.bool,
  responsive: PropTypes.object,
  arrows: PropTypes.bool,
  partialVisible: PropTypes.bool,
  infinite: PropTypes.bool,
};

ResourcesCarousel.defaultProps = {
  slidesToSlide: 4,
  swipeable: true,
  infinite: false,
  arrows: true,
  partialVisible: false,
};

const CustomArrowPropTypes = {
  onClick: PropTypes.func,
};

CustomLeftArrow.propTypes = CustomArrowPropTypes;
CustomRightArrow.propTypes = CustomArrowPropTypes;

export default ResourcesCarousel;
